/* eslint-disable max-lines-per-function */
/* eslint-disable max-statements */
import { parse } from 'querystring';
import { Config } from '@catalogo/core-configuration';
import { getCurrentSku } from '@catalogo/core-sku';
import { PageLoadEvent } from '../../../types/events';
import { Offer, Product, Paymentsoptionstype } from '../../../types/page';
import { PageViewEvent } from '../../../types/datalayer/pageview';
import {
  getMarca,
  getSellerName,
  getSellerType,
  getOfferClassificationType,
  getSellers,
  getStampPrime,
  getMeioPagamento,
  getPfm,
} from './helpers';

export default (pageload: PageLoadEvent, config: Config): PageViewEvent => {
  const parsedQs = parse(window.location.search.replace('?', ''));
  const { page, pickUpStoreOffers = [], buyboxToken, mainOffer } = pageload.detail;
  const product = pageload.detail.product || ({} as Product);
  const { id, name, attributes, rating, sellerTypeClassification, skus } = product;
  const brand = config.brand.toUpperCase();
  const marca = getMarca(attributes);
  const offersSku = skus.reduce((skuOffer: Offer[], { offers }) => offers && skuOffer.concat(offers.result), []);
  const ratingAverage = Number(rating?.average || 0).toFixed(1);
  const categoryIds = page.breadCrumb.map(({ id }) => id).join('/');
  const departmentName = page.breadCrumb.map(({ name }) => name.replace('/', '|')).join('/');
  const { stockWarning, bestPaymentOption } = mainOffer || {};
  const { type: paymentType, price, minQuantity } = bestPaymentOption || {};
  const sku = getCurrentSku({ product }, parsedQs);

  const meioPagamento = getMeioPagamento({
    BOLETO: mainOffer?.boleto,
    CARTAO: mainOffer?.cartaoVisa,
    CARTAO_FINANCE: mainOffer?.cartaoMarca,
  } as Paymentsoptionstype);

  const pagenameProduct = `${brand}:${page.breadCrumb
    .map(({ name }) => name.replace(/ /g, '-'))
    .join(':')
    .toLowerCase()}:${id}`;

  return {
    pagename: pagenameProduct,
    departmentID: categoryIds,
    departmentName: departmentName,
    Sellers: offersSku?.map(offer => `${offer?.seller?.id}`).join(','),
    ecommerce: {
      detail: {
        products: [
          {
            id: id,
            name,
            price: paymentType === 'BOLETO' ? price : minQuantity && minQuantity[0].total,
            brand: marca,
            category: departmentName,
            metric30: ratingAverage,
            metric31: stockWarning ? stockWarning : undefined,
            dimension7: getPfm(parsedQs),
            dimension14: getSellerName(mainOffer, config.sellerName),
            dimension27: offersSku?.length < 1 ? 'Sem Estoque' : 'Com Estoque',
            dimension34: getSellerType(offersSku?.[0]),
            dimension35: getOfferClassificationType(offersSku, sellerTypeClassification),
            dimension37: (mainOffer?.currency && (mainOffer?.currency !== 'BRL' ? 'Mundo' : 'BR')) || undefined,
            dimension45: marca,
            dimension46: ratingAverage,
            dimension47: rating && rating.reviews,
            dimension55: mainOffer?.seller.id,
            dimension57: pickUpStoreOffers.length > 0 ? 'SIM' : 'NÃO',
            dimension58: skus[0].offers?.meta?.total,
            dimension59: getSellers(offersSku?.length),
            dimension63: mainOffer?.salesPrice,
            dimension65: getStampPrime(offersSku) ? 'SIM' : 'NÃO',
            dimension70: buyboxToken,
            dimension77: mainOffer && mainOffer.group?.length > 0 ? 'SIM' : 'NÃO',
            dimension80: mainOffer?.id,
            dimension82: mainOffer?.condition,
            dimension85: meioPagamento,
            dimension88: stockWarning ? 'SIM' : 'NÃO',
            dimension94: mainOffer?.b2wEntregas ? 'SIM' : 'NÃO',
            dimension119: mainOffer?.sku,
            dimension126: paymentType === 'BOLETO' ? price : minQuantity && minQuantity[0].total,
            dimension128: categoryIds,
            dimension138: sku?.offers?.result?.[0]?.stamps?.fulfillment ? 'SIM' : 'NÃO',
          },
        ],
      },
    },
  } as PageViewEvent;
};
